import type { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import type { UseRefinementListProps } from "react-instantsearch-core-v7";
import type { ProductFilteredLabels } from "src/hooks/useFilterProductLabels";
import type { CategoryNodeType } from "src/molecules/CategoryTree";
import type { DeprecatedAlgoliaSearchProduct } from "src/types/Algolia";
import type { CatalogBrand, CatalogProduct } from "src/types/graphql.d";

export function generateTree<T, N>({
  items,
  brandName,
  transform,
}: {
  items: T[];
  brandName?: string;
  transform: (item: T, brandName?: string) => N;
}): N[] {
  return items.map<N>((item) => transform(item, brandName));
}

export function transformCategoryValue(
  item: RefinementListItem,
  brandName?: string
): CategoryNodeType {
  const itemValues = item.value.split("||");
  const itemId = itemValues[0];
  const label = itemValues[1];
  const slug = itemValues[2];
  const parentId = itemValues[3];
  const categoryPageId = itemValues.at(-1) || "";

  return {
    itemId,
    label,
    parentId,
    value: item.value,
    isRefined: item.isRefined,
    count: item.count,
    categoryPageId,
    slug,
  };
}

export function generateProductCardProps(
  product: DeprecatedAlgoliaSearchProduct,
  labels: ProductFilteredLabels
): CatalogProduct {
  return {
    ...product,
    id: product.objectID,
    name: product.name,
    price: product.price,
    regular_price: product.regular_price,
    brand: {
      name: product.brand_name || "",
    } as CatalogBrand,
    thumbnail: product.image || "",
    labels: labels[product.slug],
  } as CatalogProduct;
}

export const sortByCategoryName: UseRefinementListProps["sortBy"] = (a, b) => {
  return (a.name.split("||").at(1)?.toLocaleLowerCase() || "") <
    (b.name.split("||").at(1)?.toLocaleLowerCase() || "")
    ? -1
    : 1;
};

export const sortByCount: UseRefinementListProps["sortBy"] = (a, b) => {
  return a.count > b.count ? -1 : 1;
};
